import { render } from "./TSteamDetails.vue?vue&type=template&id=5fa4c58a"
import script from "./TSteamDetails.vue?vue&type=script&lang=js"
export * from "./TSteamDetails.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__